/** The model providers a Customer can add a key for (Settings and the
 * onboarding wizard). */
export const PROVIDERS = [
  { id: "openai", label: "OpenAI", placeholder: "sk-..." },
  { id: "anthropic", label: "Anthropic", placeholder: "sk-ant-..." },
  { id: "deepseek", label: "DeepSeek", placeholder: "sk-..." },
] as const;
